<template>
  <v-app id="inspire">
    <v-navigation-drawer
      app
      temporary
      v-if="isLoggedIn"
      color="#EEEEEE"
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
    >
      <v-list dense>
        <v-list-item two-line v-if="isLoggedIn" class="mb-2">
          <v-list-item-avatar>
            <v-icon x-large>mdi-account</v-icon>
          </v-list-item-avatar>
          <v-list-item-content class="mt-6">
            <v-list-item-title class="font-weight-bold text-uppercase">{{ currentUser.nombre }}</v-list-item-title>
            <v-list-item-subtitle class="text-uppercase">Usuario en Sesión</v-list-item-subtitle>
            <div align="right" class="mt-1">
              <v-btn x-small color="primary" dark to="/perfil">Mi perfil</v-btn>
            </div>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-group
          v-if="currentRole == 1 || currentRole == 2"
          prepend-icon="mdi-list"
        >
          <template v-slot:activator>
            <v-list-item-title class="ml-n11">CATÁLOGOS</v-list-item-title>
          </template>
          <v-list-item
            v-for="(menu, i) in adminCatalogo"
            :key="i"
            link
            :to="menu.link"
          >
            <v-list-item-title v-text="menu.text"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider class="mb-3"></v-divider>
        <v-list-group prepend-icon="mdi-list" v-if="currentRole == 3 || currentRole == 4 || currentRole == 6">
          <template v-slot:activator>
            <v-list-item-title class="ml-n11">PANEL</v-list-item-title>
          </template>
          <v-list-item v-if="currentRole == 3 || currentRole == 4" link to="/tocas">
            <v-list-item-title>Tocas</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item v-if="currentRole == 3" link to="/colegiadas">
            <v-list-item-title>Colegiadas</v-list-item-title>
          </v-list-item> -->
          <v-list-item v-if="currentRole == 3" link to="/asignacion">
            <v-list-item-title>Ver mi Turno</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="currentRole == 3" link to="/pendientes/firma">
            <v-list-item-title>Pendientes de firma</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="currentRole == 6" link to="/secacuerdos">
            <v-list-item-title>Lista de Tocas</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="currentRole == 6" link to="/comunicados/list">
            <v-list-item-title>Comunicados</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="currentRole == 6" link to="/documentos-pendientes-de-firmar">
            <v-list-item-title>Pendientes de evidencia</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="currentRole <= 4 || currentRole == 6" link to="/previsualizaciones">
            <v-list-item-title>Previsualizaciones</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- <v-list-group
          v-if="currentRole == 1 || currentRole == 2"
          prepend-icon="mdi-list"
        >
          <template v-slot:activator>
            <v-list-item-title class="ml-n11">ESTADÍSTICAS</v-list-item-title>
          </template>
          <v-list-item link to="/abogados">
            <v-list-item-title>Estadísticas Abogados</v-list-item-title>
          </v-list-item>
          <v-list-item link to="/estadistica">
            <v-list-item-title>Estadísticas Apelaciones</v-list-item-title>
          </v-list-item>
        </v-list-group> -->
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn @click="logout" block color="grey darken-3 white--text">
            <v-icon>mdi-lock</v-icon> Salir
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <img src="@/assets/SISGEOWEBSALA11.svg" class="hidden-sm-and-down" style="width:100%;height:auto">
    <img src="@/assets/SISGEOMOVSALA11.svg" class="hidden-md-and-up" style="width:100%;height:auto">
    <template>
      <v-card class="overflow-hidden">
        <v-app-bar
          :clipped-left="$vuetify.breakpoint.lgAndUp"
          dark
          dense
          color="#373736"
        >
          <v-app-bar-nav-icon
            class="hidden-md-and-up"
            v-if="isLoggedIn"
            @click.stop="drawer = !drawer"
          />
          <v-btn text>
            <img src="@/assets/logo_nuevo.png" width="30" height="31">
          </v-btn>
          <div v-if="isLoggedIn">
            <v-menu offset-y v-if="currentRole == 1 || currentRole == 2">
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark v-bind="attrs" v-on="on" class="hidden-sm-and-down ml-2">
                  CATÁLOGOS
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(menu, i) in adminCatalogo" :key="i" link :to="menu.link">
                  <v-list-item-title v-text="menu.text"></v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-menu offset-y v-if="currentRole == 3 || currentRole == 4 || currentRole == 6 || currentRole == 9">
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark v-bind="attrs" v-on="on" class="hidden-sm-and-down ml-2">
                  PANEL
                </v-btn>
              </template>
              <v-list>
                <!-- <v-list-item v-for="(item, i) in menuSolicitudes" :key="i" link :to="item.link">
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item> -->
                <!-- <v-list-item v-if="currentRole == 3" link to="/colegiadas">
                  <v-list-item-title>Colegiadas</v-list-item-title>
                </v-list-item> -->
                <v-list-item v-if="currentRole == 3 || currentRole == 4" link to="/tocas">
                  <v-list-item-title>Tocas</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="currentRole == 3" link to="/asignacion">
                  <v-list-item-title>Ver mi Turno</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="currentRole == 3" link to="/pendientes/firma">
                  <v-list-item-title>Pendientes de Firma</v-list-item-title>
                </v-list-item>
                <!-- Tocas/Index Secretario de Acuerdos -->
                <v-list-item v-if="currentRole == 6 || currentRole == 9" link to="/secacuerdos">
                  <v-list-item-title>Tocas</v-list-item-title>
                </v-list-item>
                <!-- Comunicados / Secretario de Acuerdos -->
                <v-list-item v-if="currentRole == 6" link to="/comunicados/list">
                  <v-list-item-title>Comunicados</v-list-item-title>
                </v-list-item>
                <!-- Pendientes de evidencia / Secretario de Acuerdos -->
                <v-list-item v-if="currentRole == 6" link to="/documentos-pendientes-de-firmar">
                  <v-list-item-title>Pendientes de evidencia</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="currentRole <= 4 || currentRole == 6" link to="/previsualizaciones">
                  <v-list-item-title>Previsualizaciones</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <!-- <v-menu offset-y v-if="currentRole == 1 || currentRole == 2">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  dark
                  class="hidden-sm-and-down ml-2"
                  v-bind="attrs"
                  v-on="on">
                  ESTADÍSTICAS
                </v-btn>
              </template>
              <v-list>
                <v-list-item link to="/abogados">
                  <v-list-item-title>Estadísticas Abogados</v-list-item-title>
                </v-list-item>
                <v-list-item link to="/estadistica">
                  <v-list-item-title>Estadísticas Apelaciones</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu> -->
          </div>
          <v-spacer />
          <v-list color="#373736" v-if="isLoggedIn" class="text-button">
            <v-list-item-icon class="d-none d-sm-flex">
              <v-icon left>mdi-account</v-icon>
              {{ currentUser.nombre }}
            </v-list-item-icon>
          </v-list>
          <v-btn icon v-if="currentUser.impersonated" @click="stopImpersonated()" class="mr-2">
            <v-icon>mdi-account-convert</v-icon>
          </v-btn>
          <v-menu
            v-if="isLoggedIn"
            bottom
            origin="center center"
            transition="scale-transition"
            offset-y
            text
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="white--text"
                color="#373736"
                v-bind="attrs"
                v-on="on"
                icon
              >
                <v-icon>mdi-lock</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="$router.push({ name:'UpdatePassword' })" class="caption">
                <v-icon small class="mr-2">mdi-key</v-icon>
                <b>ACTUALIZAR CONTRASEÑA</b>
              </v-list-item>
              <v-list-item @click="logout" class="caption">
                <v-icon small class="mr-2">mdi-logout</v-icon>
                <b>CERRAR SESIÓN</b>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-app-bar>
      </v-card>
    </template>

    <v-main>
      <v-container fluid style="background-color:">
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-footer padless color="#373736" dark>
      <v-col class="text-center" cols="12">
        {{ new Date().getFullYear() }} — <strong>STJ</strong>
      </v-col>
    </v-footer>

  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    source: String
  },
  data: () => ({
    dialog: false,
    drawer: null,
    adminCatalogo: [
      { icon: "mdi-chevron-right", text: "Roles", link: "/roles" },
      { icon: "mdi-chevron-right", text: "Usuarios", link: "/users" },
      { icon: "mdi-chevron-right", text: "Delitos", link: "/delitos" },
      { icon: "mdi-chevron-right", text: "Sentidos", link: "/sentidos" },
      { icon: "mdi-chevron-right", text: "Categorias", link: "/categorias" },
      { icon: "mdi-chevron-right", text: "Tipo de Documentos", link: "/tipo_documentos" },
    ],
    // menuSolicitudes: [
    //   { icon: "mdi-chevron-right", text: "Tocas", link: "/tocas" },
    //   { icon: "mdi-chevron-right", text: "Amparos", link: "/amparos" },
    // ],
    currentRole:''
  }),
  computed: {
    ...mapGetters(["roleUser", "isLoggedIn", "currentUser"])
  },
  mounted() {
    if (this.currentUser) {
      this.currentRole = this.currentUser.roles[0].id
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("LOGOUT").then(() => {
          this.$swal({
            title: "Ha cerrado Sesión ",
            icon: "success",
            timer: 1000
          });
          window.location = "/"
        })
        .catch(error => {
          this.$swal({
            title: "Error",
            text: "No se pudo Cerrar la Sesión Correctamente",
            icon: "error",
            confirmButtonText: "Aceptar"
          });
        });
    },
    stopImpersonated(){
      this.$store.dispatch("IMPERSONATE_STOP",
        { url: "/impersonate-stop" } )
      .then(response => {
        localStorage.setItem("token", response.data.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.data.user));
        this.$swal({
          icon: 'success',
          title: 'Impersonated Stoped successfuly!!!',
          confirmButtonText: "Aceptar"
        })
        window.location = "/users"
      }).catch(error => {
        console.log(error);
      });
    }
  }
};
</script>
